<template>
  <div class="nav-dots">
    <!-- <div class="nav-links">
      <router-link to="/">Datos Básicos</router-link> |
      <router-link to="/dni">Datos del DNI</router-link>
      <router-link to="/data-validation">Validación de Datos</router-link>
      <router-link to="/additional-information">Información Adicional</router-link>
    </div> -->
    <div class="step">
      <h3>Paso {{screenStep}}</h3>
    </div>
    <div :key="index" v-for="(screenElement, index) in screens"
      :class="{ 'active': index <= screen, 'circleBase': true }">
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavDots',
  props: {
    screen: Number,
  },
  data() {
    return {
      screens: Array(4),
    };
  },
  computed: {
    screenStep() {
      if (this.$props.screen > 3) {
        return 4;
      }
      return this.$props.screen + 1;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/css/variables.scss';
h3 {
  font-size: 18px;
  letter-spacing: 2px;
  margin-bottom: 14px;
  @media screen and (min-width: $break-sm) {
    margin-bottom: 17px;
  }
}
.circleBase {
    border-radius: 50%;
    width: 10px;
    height: 10px;
    background: #c0f4d9;
    display: inline-block;
    margin: 0 10px;
    @media screen and (min-width: $break-sm) {
      width: 13px;
      height: 13px;
      margin: 0 10px;
    }
}
.active {
    background: #00d667;
}
</style>
